import { useEffect, useRef, useState } from "react";
import { Container, FloatingLabel, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Column, Icon, Panel, Select } from "../../../../components";
import { CustomerScreentLables as cstScrLables } from "../../../../shared/util/label";
import Customer_CoInsured from "../../../model/Customer-CoInsured";
import './Customer-CoInsured.scss';
import { InputMask } from 'primereact/inputmask';
import { updateSelectedPolicyDetails } from "../../../customer-slice/Customer-slice";
import { RootState } from "../../../../shared/store";
import { CommonUtility } from "../../../../Services/CommonUtility";
import { uuid } from "../../../../shared/util/uuid";

export interface ICustomerCoInsured {
     validationErrors?: any;
     tabIndex?: number;
}

const CustomerCoInsured: React.FunctionComponent<ICustomerCoInsured> = (props) => {
    let tbindex = props.tabIndex;
   const { validationErrors } = props;
    const { policyId, polEventId } = useSelector((state: RootState) => ({
        policyId: state.customerSlice.policyId,
        polEventId: state.customerSlice.polEventId
    }));

    const dispatch = useDispatch();

    // Get policy details from Redux using composite key   
    const policyDetailKey = CommonUtility.getPolicyDetailKey(policyId, polEventId);
    const customerpolicyDetail = useSelector((state: RootState) => state?.customerSlice);
    const policyDetails = customerpolicyDetail.selectedPolicyDetails?.[policyDetailKey];
    const coInsured: Customer_CoInsured = policyDetails?.policyCoInsureds?.[0] || {};

    const [formValidation, setFormValidation] = useState<any>({});

    //Customer details related constents end here

    const [isEditable, setIsEditable] = useState(true);
    const contactInoLg = 4;
    const contactInoMd = 4;

    const firstNameRef = useRef(null)

    const defaultCoInsured: Customer_CoInsured = {
        polId: policyId,
        polEventId: polEventId,
        id: uuid(),
        effDate: new Date()
    };

    const onEntityFieldChange = (propName: string, value: string | Date | boolean) => {
        if (policyDetails) {
            const updatedCoInsureds = [...(policyDetails.policyCoInsureds && policyDetails.policyCoInsureds.length > 0 ? policyDetails.policyCoInsureds : [defaultCoInsured])];
            updatedCoInsureds[0] = { ...updatedCoInsureds[0], [propName]: value };
            const updatedPolicyDetails = { ...policyDetails, policyCoInsureds: updatedCoInsureds };
            dispatch(updateSelectedPolicyDetails({
                policyId,
                polEventId,
                policyDetails: updatedPolicyDetails,
            }));
        }
    };

      // Set validation errors from props to formValidation state
            useEffect(() => {
                if (validationErrors) {                    
                    setFormValidation(validationErrors);
                }
            }, [validationErrors]);

    return (
        <>
            <Container fluid>
                <Row >
                    <Column md={12}>
                        <Panel title={'Customer Information'} className={'customerPanel cstPanel customerOverview mt-2'} cardBodyClassName="pt-0" collapsible={false}>
                            <Row className="p-2 border-top customer-edit-policy-button" style={{ paddingTop: "10px" }}>
                                <Column lg={12} md={12} className="section-height customer-edit-policy-column">
                                    <Row>
                                        <Column lg={contactInoLg} md={contactInoMd} className={formValidation['cofirstName']?.isValid == false ? 'feedback-row' : ''}>
                                            <FloatingLabel controlId="firstName"
                                                label={<>{cstScrLables.FIRST_NAME}</>}
                                                className="mb-3" >
                                                <Form.Control
                                                    type="text"
                                                    placeholder={cstScrLables.FIRST_NAME}
                                                    tabIndex={tbindex++}
                                                    name="firstName"
                                                    ref={firstNameRef}
                                                    value={coInsured.firstName ?? ""}
                                                    onChange={(event) => onEntityFieldChange('firstName', event.currentTarget.value)}
                                                    disabled={!isEditable}
                                                    // required={true}
                                                    maxLength={60}
                                                    isInvalid={formValidation['cofirstName']?.isValid == false}
                                                />
                                                {formValidation['cofirstName']?.isValid == false && (
                                                    <Form.Control.Feedback type="invalid">
                                                        {formValidation['cofirstName']?.warningText}
                                                    </Form.Control.Feedback>
                                                )}
                                            </FloatingLabel>
                                        </Column>
                                        <Column lg={contactInoLg} md={contactInoMd}>
                                            <FloatingLabel
                                                controlId="midName"
                                                label={cstScrLables.MIDDLE_NAME}
                                                className="mb-3"
                                            >
                                                <Form.Control
                                                    type="text"
                                                    tabIndex={tbindex++}
                                                    placeholder=" "
                                                    name="midName"
                                                    value={coInsured.midName ?? ""}
                                                    onChange={(event) => onEntityFieldChange('midName', event.currentTarget.value)}
                                                    disabled={!isEditable}
                                                    maxLength={60}
                                                />
                                            </FloatingLabel>
                                        </Column>
                                        <Column lg={contactInoLg} md={contactInoMd}
                                            className={formValidation['colastName']?.isValid == false ? 'feedback-row' : ''}>
                                            <FloatingLabel controlId="lastName"
                                                label={<>{cstScrLables.LAST_NAME}</>}
                                                className="mb-3"                                            >
                                                <Form.Control
                                                    type="text"
                                                    placeholder={cstScrLables.LAST_NAME}
                                                    tabIndex={tbindex++}
                                                    name="lastName"
                                                    value={coInsured.lastName ?? ""}
                                                    onChange={(event) => onEntityFieldChange('lastName', event.currentTarget.value)}
                                                    disabled={!isEditable}
                                                    // required
                                                    maxLength={60}
                                                    isInvalid={formValidation['colastName']?.isValid == false}
                                                />
                                                {formValidation['colastName']?.isValid == false && (
                                                    <Form.Control.Feedback type="invalid">
                                                        {formValidation['colastName']?.warningText}
                                                    </Form.Control.Feedback>
                                                )}
                                            </FloatingLabel>
                                        </Column>
                                    </Row>
                                       <Row>
                                        <Column lg={contactInoLg} md={contactInoMd}
                                            className={formValidation['cohomePhone']?.isValid == false ? 'feedback-row' : ''}>
                                            <div className="input-group has-validation">
                                                <span className="input-group-text remove-right-radius mb-3">
                                                    <Icon icon="home" className="text-muted fa-fw" />
                                                </span>
                                                <FloatingLabel controlId="homePhone"
                                                    label={<>{cstScrLables.HOME_PHONE}</>}
                                                    className="mb-3"
                                                     
                                                    >
                                                    <InputMask
                                                        name="homePhone"
                                                        tabIndex={tbindex++}
                                                        value={coInsured.homePhone}
                                                        onChange={(event) => onEntityFieldChange('homePhone', event.value)}
                                                        mask={cstScrLables.PHONE_MASK}
                                                        placeholder=""
                                                        required={true}
                                                        // invalid={formValidation['cohomePhone']?.isValid === false}
                                                         />
                                                    <label>{cstScrLables.HOME_PHONE}</label>
                                                   
                                                    {/* {formValidation['cohomePhone']?.isValid === false && (
                                                        <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                                            {formValidation['cohomePhone']?.warningText}
                                                        </Form.Control.Feedback>
                                                    )} */}
                                                </FloatingLabel>
                                            </div>
                                        </Column>

                                        <Column lg={contactInoLg} md={contactInoMd}
                                            className={formValidation['coworkPhone']?.isValid == false ? 'feedback-row' : ''}>
                                            <div className="input-group has-validation">
                                                <span className="input-group-text remove-right-radius mb-3">
                                                    <Icon icon="building" className="text-muted fa-fw" />
                                                </span>
                                                <FloatingLabel controlId="workPhone"
                                                    label={<>{cstScrLables.WORK_PHONE}</>}
                                                    className="mb-3">
                                                    <InputMask
                                                        name="workPhone"
                                                        tabIndex={tbindex++}
                                                        value={coInsured.workPhone}
                                                        onChange={(event) => onEntityFieldChange('workPhone', event.value)}
                                                        mask={cstScrLables.PHONE_MASK}
                                                        placeholder="" />
                                                    <label>{cstScrLables.WORK_PHONE}</label>
                                                    {/* {formValidation['coworkPhone']?.isValid == false && (
                                                        <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                                            {formValidation['coworkPhone']?.warningText}
                                                        </Form.Control.Feedback>
                                                    )} */}
                                                </FloatingLabel>
                                            </div>
                                        </Column>
                                        <Column lg={contactInoLg} md={contactInoMd}
                                            className={formValidation['comobile']?.isValid == false ? 'feedback-row' : ''}>
                                            <div className="input-group has-validation">
                                                <span className="input-group-text remove-right-radius mb-3">
                                                    <Icon icon="mobile" className="text-muted fa-fw" />
                                                </span>
                                                <FloatingLabel controlId="mobile"
                                                    label={<>{cstScrLables.MOBILE}</>}
                                                    className="mb-3">
                                                    <InputMask
                                                        name="mobile"
                                                        tabIndex={tbindex++}
                                                        value={coInsured.mobile}
                                                        onChange={(event) => onEntityFieldChange('mobile', event.value)}
                                                        mask={cstScrLables.PHONE_MASK}
                                                        placeholder="" 
                                                        />
                                                    {/* {formValidation['comobile']?.isValid == false && (
                                                        <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                                            {formValidation['comobile']?.warningText}
                                                        </Form.Control.Feedback>
                                                    )} */}
                                                </FloatingLabel>
                                            </div>
                                        </Column>
                                        
                                    </Row>
                                    <Row>
                                        <Column lg={contactInoLg} md={contactInoMd}
                                            className={formValidation['coeMail']?.isValid == false ? 'feedback-row' : ''}>

                                            <div className="input-group has-validation">
                                                <span className="input-group-text remove-right-radius mb-3">
                                                    <Icon icon="email" className="text-muted fa-fw" />
                                                </span>
                                                <FloatingLabel controlId="eMail"
                                                    label={<>{cstScrLables.EMAIL}</>}
                                                    className="mb-3">
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={cstScrLables.NO_OF_MEMBERS}
                                                        tabIndex={tbindex++}
                                                        name="eMail"
                                                        value={coInsured.eMail ?? ""}
                                                        onChange={(event) => onEntityFieldChange('eMail', event.currentTarget.value)}
                                                        disabled={!isEditable}
                                                        // required
                                                        maxLength={100}
                                                        // isInvalid={formValidation['coeMail']?.isValid == false}
                                                    />
                                                    {/* {formValidation['coeMail']?.isValid == false && (
                                                        <Form.Control.Feedback type="invalid">
                                                            {formValidation['coeMail']?.warningText}
                                                        </Form.Control.Feedback>
                                                    )} */}
                                                </FloatingLabel>
                                            </div>
                                        </Column>
                                        </Row>
                                </Column>
                            </Row>
                        </Panel>
                    </Column>
                </Row>
            </Container>
        </>
    );
};
export default CustomerCoInsured;